import { Ok, ThinCross } from 'icons';

import styles from './CheckboxNoEditIcon.module.scss';

interface Props {
  isSelectedItem?: boolean;
  emptyNoSelected?: boolean;
}

export const CheckboxNoEditIcon = ({ isSelectedItem, emptyNoSelected }: Props) => {
  if (emptyNoSelected && !isSelectedItem) {
    return null;
  }

  return isSelectedItem ? <Ok className={styles.ok} /> : <ThinCross className={styles.close} />;
};
